import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import AnalyticsLayout from '@/views/v2/layouts/store_management/Analytics.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import MallActiveStoresCount from '@/components/v2/store_management/MallActiveStoresCount.vue';
import MallInactiveStoresCount from '@/components/v2/store_management/MallInactiveStoresCount.vue';
import MostVisitedStores from '@/components/v2/store_management/MostVisitedStores.vue';
import MostStoreTotalSales from '@/components/v2/store_management/MostStoreTotalSales.vue';
import MallDailyStoreVisit from '@/components/v2/store_management/MallDailyStoreVisit.vue';
let StoreManagementOverview = class StoreManagementOverview extends Mixins(ViewportSizeMixin) {
};
StoreManagementOverview = __decorate([
    Component({
        components: {
            AnalyticsLayout,
            MallActiveStoresCount,
            MallInactiveStoresCount,
            MostVisitedStores,
            MostStoreTotalSales,
            MallDailyStoreVisit,
        },
    })
], StoreManagementOverview);
export default StoreManagementOverview;
